/**
 * <s-share> — product share menu helpers.
 * - [data-share-copy]: copies data-url to the clipboard and announces data-copied-message.
 * - [data-share-native]: hidden until navigator.share exists (mostly phones); opens the
 *   device share sheet so buyers can reach Instagram, messages, etc.
 * The menu itself is a native <details> element, so links work without JavaScript.
 */
import { announceGlobalLiveRegion } from '@theme/live-region';

class SShare extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    const nativeButton = this.querySelector('[data-share-native]');
    if (nativeButton && typeof navigator.share === 'function') {
      nativeButton.hidden = false;
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = async (event) => {
    const copyButton = event.target.closest('[data-share-copy]');
    const nativeButton = event.target.closest('[data-share-native]');
    const url = this.dataset.url;
    if (copyButton && url) {
      try {
        await navigator.clipboard.writeText(url);
        const label = copyButton.querySelector('[data-share-copy-label]');
        if (label) {
          const original = label.textContent;
          label.textContent = this.dataset.copiedMessage;
          setTimeout(() => { label.textContent = original; }, 2000);
        }
        announceGlobalLiveRegion(this.dataset.copiedMessage);
      } catch {
        window.prompt(this.dataset.copyPrompt, url);
      }
    }
    if (nativeButton && url) {
      try {
        await navigator.share({ title: this.dataset.title, url });
      } catch {
        // Buyer closed the share sheet.
      }
    }
  };
}

if (!customElements.get('s-share')) {
  customElements.define('s-share', SShare);
}
